import { useEffect } from 'react';

import { FlexGrid, Spacer } from '@telus-uds/components-web';

import useStore from '../../../../store/store';

import AddProject from './components/AddProject';
import ProjectList from './components/ProjectList';
import Notification from '../../../../components/Notification';

export default function Projects() {
  const { fetchProjects, projectMessage, setProjectMessage } = useStore(
    (state) => state
  );

  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <>
      <Spacer space={6} />
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col sm={12} md={12} lg={4}>
            <AddProject />
            <Spacer space={6} />
          </FlexGrid.Col>
          <FlexGrid.Col sm={12} md={12} lg={8}>
            {projectMessage?.active && (
              <>
                <Notification
                  data={projectMessage}
                  action={setProjectMessage}
                />
                <Spacer space={4} />
              </>
            )}
            <ProjectList />
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </>
  );
}
